import React, { useState, useEffect } from "react";
import "./SubscriptionSetup.css"; // You can style this in your separate CSS file

import { useNavigate } from 'react-router-dom';
import Util from './ait/Util.js';
import { loadStripe } from '@stripe/stripe-js';
import Swal from 'sweetalert2';

const SubscriptionSetup = ({auth, onAuth, onLogout}) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loadingAction, setLoadingAction] = useState(null);
  // const [trialDone,setTrialDone] = useState(false);
  const navigate = useNavigate();

  // Replace with your public Stripe key (starts with pk_test_...)
  const stripePromise = loadStripe('pk_test_51RBmzJQ01vR94bQqigFiX0TlK4WDJ2f7OtW2ypqjswQngs8tmEFbw7EGT99ySpghMYmhXXj7xLyMY7GhfHsu50uT00mOEiximr');


  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include", // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };
  

  useEffect(() => {
    
    if(auth.user.sysPage != true)
    {
      if(auth.user.inactive===true)
      {
        navigate('/email-verification');
        return;
      }

      if(auth.user.subscribed==true)
      {
        navigate('/dashboard');
      }
    }
    else
    {
      navigate('/dashboard');
    }
    
    // If the function has any side effects, you can also clean up after it
    return () => {
      // Optional cleanup if needed
      console.log('Cleaning up when MyComponent is unmounted');
    };
  }, []); // The empty dependency array means it only runs once, when the component is mounted


  const handlePaidSubscription = async () => {
    try {
      const response = await fetchWithAuth('/protected/createSubscriptionSession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email:auth.user.userId }),
      });
  
      const data = await response.json();
    
      if(data.status===false)
      {
          setError(data.message)
          return;
      }
  
      if (data.url) {
        // Option 1: direct redirect (recommended)

        console.log("data URL: ", data.url);
        window.location.href = data.url;

  
        // Option 2: using Stripe.js (optional alternative)
        // const stripe = await stripePromise;
        // stripe.redirectToCheckout({ sessionId: data.id });
      } else {
        console.error('No URL returned from backend:', data);
        alert('Error starting subscription');
      }
    } catch (err) {
      console.error('Subscription error:', err);
      alert('Something went wrong while trying to subscribe');
    }
  }
  

  // Handle deleting website
  const handleDeleteWebsite = async () => {
    const result = await Swal.fire({
      title: 'Delete website?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33'
    });
  
    if (result.isConfirmed) {
      console.log('Deleting website...');
      await execDeleteWebsite();
    }
  };

  const handleEraseAccount = async () => 
  {
    setError("");
    setLoadingAction("erase");

    try
    {
      const command = Util.serverName + "/protected/getUserDirList";
      const response = await fetchWithAuth(command, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (!response.ok) {
        return;
      }

      if (!data.status) {        
        return;
      }

      if(data.files.length !== 0)
      {
        Swal.fire({
          title: 'Info',
          text: "You must delete all files in your account first before erasing",
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });    
      }

      const result = await Swal.fire({
        title: 'Erase Account?',
        text: 'After this operation, you will lose your webId and will have to sign up again.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, erase it',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33'
      });
    
      if (result.isConfirmed) 
      {
        console.log('Deleting website...');
        await execEraseAccount();
      }
    }
    catch(e)
    {
      console.log("Exception occurred erasing account");
    }
    finally
    {
      setLoadingAction(null);
    }
  }

  const execEraseAccount = async () =>
  {
    try {

      const command = Util.serverName + "/protected/eraseAccount"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Erase Account");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");    
      window.location.reload();  
    } 
    catch(e)
    {
      console.log("Exception in execEraseAccount: ", e.msg);
    }
    finally {

    }
  }

  const execDeleteWebsite = async () =>
  {
    try {
      setError("");
      setLoadingAction("delete");

      const command = Util.serverName + "/protected/deleteWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Delete Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");      
    } finally {
      setLoadingAction(null);
    }
  }


  async function downloadZip() {
    try {
      setLoadingAction("download");
  
      const command = Util.serverName + "/protected/downloadZip";
  
      const response = await fetchWithAuth(command);
  
      if (!response.ok) {
        const errorData = await response.json();
              // alert("Please select a file first!");
        Swal.fire({
          title: 'Info',
          text: errorData.message,
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });    

        // alert(errorData.message);
        return;
      }
  
      const blob = await response.blob();
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
  
      a.href = url;
      a.download = `${auth.user.webId}.zip`;
  
      document.body.appendChild(a);
      a.click();
  
      a.remove();
      window.URL.revokeObjectURL(url);
  
    } catch (err) {
      console.error("Download failed:", err);
      alert("Download failed");
    } finally {
      setLoadingAction(null);
    }
  }

  /*
  async function downloadZip() 
  {
    try
    {
      setLoadingAction("download");
      const command = Util.serverName + "/protected/downloadZip"; // Base API endpoint
      await fetchWithAuth(command)
          .then(response => response.blob())  // Convert response to a Blob
          .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${auth.user.webId}.zip`; // Suggested filename
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url); // Clean up
          })
          .catch(err => console.error('Download failed:', err));
      }
      finally
      {
        setLoadingAction(null);
      }
  }
*/
  // Handle deleting website
  const handleDownloadWebsite = () => {
    console.log("Downloading Site");
    // Call this function when the user clicks a button
    downloadZip();
  };

  return (
    <div className="subscription-container">
      <h2>Manage Your Account Or Subscribe</h2>
      <p>
        Subscribe to unlock MyAiWeb's website builder and hosting features. If you already have files stored on MyAiWeb, you can manage or remove them below.        
      </p>
      <div className="tier-container">
        <div className="tier">
          <h3>Manage Files</h3>
          <p>
            Download your website files to your computer            
          </p>
          <button
              onClick={handleDownloadWebsite}
              className="tier-button"
              disabled={loadingAction === "download"}
            >
              {loadingAction === "download" ? (
                <>
                  <span className="spinner"></span>
                  Downloading...
                </>
              ) : (
                "Export Your Website"
              )}
          </button>
          <p>
            This permanently deletes all website files stored on the server. Download a copy first if you want to keep your files.            
          </p>

          <button
              onClick={handleDeleteWebsite}
              className="tier-button"
              disabled={loadingAction === "delete"}
            >
              {loadingAction === "delete" ? (
                <>
                  <span className="spinner"></span>
                  Deleting...
                </>
              ) : (
                "Delete Your Website"
              )}
          </button>
          <p>
            This permanently deletes your account and login credentials. All website files must be removed before deleting your account.
          </p>

          <button
              onClick={handleEraseAccount}
              className="tier-button"
              disabled={loadingAction === "erase"}
            >
              {loadingAction === "erase" ? (
                <>
                  <span className="spinner"></span>
                  Erasing...
                </>
              ) : (
                "Erase Your Account"
              )}
          </button>
        </div>
        <div className="tier">
          <h3>Paid Plan</h3>
          <p>
            Create and host your own digital poster-style website for $15 USD/month.
            Use AI assistance to help build and customize your site.            
          </p>
          <button
            onClick={() => handlePaidSubscription()}
            className={`tier-button`}
          >
            Subscribe
          </button>

          {/*
            <PayPalSubscriptionButton />
          */}
        </div>
      </div>

      {loading && <div className="loading">Processing...</div>}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default SubscriptionSetup;

